import { useFetchUserStatusQuery } from '@/api/user-api'
import { mapDollarSign } from '@/utils/map-currency'

function useWorkspaceDollarSign(): string {
  const { data: userStatus } = useFetchUserStatusQuery()

  return mapDollarSign(userStatus?.currentWorkspace?.currencyCode)
}

export default useWorkspaceDollarSign
